import $ from 'jquery';

$(document).ready(function () {
  $('.box-repeater-items').each(function () {
    $(this).not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      appendDots: '.dots-wrap',
    });
  });
});
